export const StorageType = Object.freeze({
  ACTIVE_SESSION_ID: 'active_session_id',
  ACTIVE_SESSION_PATH: 'active_session_path'
});



// WEBPACK FOOTER //
// ./src/enums/StorageType.js